export async function apiFetch(input: RequestInfo, init: RequestInit = {}) {
  // Prefer session token over Google ID token
  const sessionToken = localStorage.getItem('session_token');
  const idToken = localStorage.getItem('id_token');
  const token = sessionToken || idToken;
  
  const headers = new Headers(init.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
    console.log('[API DEBUG] Added Auth header. Token type:', sessionToken ? 'session' : 'google', 'Token length:', token.length);
  } else {
    console.warn('[API DEBUG] No token found in localStorage');
  }
  const response = await fetch(input, { ...init, headers });

  if (response.status === 401) {
    console.warn('[API] 401 Unauthorized detected. Attempting to refresh session...');
    
    // Try to refresh session if we have a token
    if (token) {
      try {
        const refreshRes = await fetch('/api/auth/refresh', {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (refreshRes.ok) {
          const data = await refreshRes.json();
          localStorage.setItem('session_token', data.sessionToken);
          // Retry original request with new token
          headers.set('Authorization', `Bearer ${data.sessionToken}`);
          const retryResponse = await fetch(input, { ...init, headers });
          if (retryResponse.status !== 401) {
            return retryResponse;
          }
        }
      } catch (refreshError) {
        console.error('[API] Failed to refresh session:', refreshError);
      }
    }
    
    // If refresh failed or no token, clear and redirect
    console.warn('[API] Clearing tokens and redirecting.');
    localStorage.removeItem('session_token');
    localStorage.removeItem('id_token');
    window.dispatchEvent(new Event('auth:unauthorized'));
    // Immediately redirect to home page to show login screen
    // Use replace to avoid adding to browser history
    window.location.replace('/');
    // Throw error to prevent further processing (like parsing JSON)
    throw new Error('Unauthorized');
  }

  return response;
} 